<div class="auth-page-wrapper">
  <div class="auth-form-container auth-form-side" [class.scrollable]="!phoneVerificationRequired">
    @if (!phoneVerificationRequired) {
      <div class="auth-card" style="max-width:620px; width:100%">
        <div class="signup-header">
          <img src="assets/logo.png" alt="Radio Ads Direct Logo" class="signup-logo">
          <h1 class="auth-heading">Create your account</h1>
          <p class="auth-subheading">Start reaching radio audiences across the US</p>
        </div>

        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
            <!-- Account Type Selection -->
            <div class="form-section">
              <h3 class="auth-section-label">Account Type</h3>
              <mat-radio-group formControlName="accounttype" aria-label="Account Type:" class="radio-group auth-account-type">
                <mat-radio-button value="individual" class="radio-button auth-account-btn" [class.auth-account-btn--active]="accountTypeControl?.value === 'individual'">
                  <div class="radio-content">
                    <mat-icon>person</mat-icon>
                    <span>Individual</span>
                  </div>
                </mat-radio-button>
                <mat-radio-button value="business" class="radio-button auth-account-btn" [class.auth-account-btn--active]="accountTypeControl?.value === 'business'">
                  <div class="radio-content">
                    <mat-icon>business</mat-icon>
                    <span>Business</span>
                  </div>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Personal Information -->
            <div class="form-section">
              <h3 class="auth-section-label">Personal Information</h3>
              <div class="form-grid">
                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" id="firstname" formControlName="firstname" placeholder=" ">
                  <label for="firstname">First Name</label>
                  @if (firstNameControl?.invalid && firstNameControl?.touched) {
                    <mat-error class="auth-error">
                      @if (firstNameControl?.errors?.['required']) {
                        First name is required
                      } @else if (firstNameControl?.errors?.['minlength']) {
                        First name must be at least 2 characters
                      }
                    </mat-error>
                  }
                </div>

                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" id="lastname" formControlName="lastname" placeholder=" ">
                  <label for="lastname">Last Name</label>
                  @if (lastNameControl?.invalid && lastNameControl?.touched) {
                    <mat-error class="auth-error">
                      @if (lastNameControl?.errors?.['required']) {
                        Last name is required
                      } @else if (lastNameControl?.errors?.['minlength']) {
                        Last name must be at least 2 characters
                      }
                    </mat-error>
                  }
                </div>
              </div>
            </div>

            <!-- What are you advertising? (Individual only) -->
            @if (showPurposeDropdown) {
              <div class="form-section">
                <h3 class="auth-section-label">What are you advertising?</h3>
                <div class="form-grid">
                  <div
                    class="auth-field auth-field--select"
                    [class.auth-field--filled]="!!signupPurposeControl?.value">
                    <mat-select
                      class="auth-select"
                      id="signupPurpose"
                      formControlName="signup_purpose_category_id"
                      panelClass="auth-select-panel"
                      hideSingleSelectionIndicator
                      disableOptionCentering
                      [placeholder]="loadingPurposeCategories ? 'Loading categories...' : 'Select one'"
                      [disabled]="loadingPurposeCategories">
                      @for (category of purposeCategories; track category.id) {
                        <mat-option [value]="category.id">{{ category.label }}</mat-option>
                      }
                      <mat-option [value]="purposeOtherSentinel">Other</mat-option>
                    </mat-select>
                    <label class="auth-field__label-top" for="signupPurpose">What are you advertising?</label>
                    @if (signupPurposeControl?.invalid && signupPurposeControl?.touched) {
                      <mat-error class="auth-error">Please select what you are advertising</mat-error>
                    }
                    @if (loadingPurposeCategories) {
                      <p class="purpose-hint">Loading categories...</p>
                    }
                  </div>
                </div>

                @if (isPurposeOtherSelected) {
                  <div class="form-grid">
                    <div class="auth-field auth-field--has-icon auth-field--filled">
                      <input
                        class="auth-input"
                        id="signupPurposeOther"
                        formControlName="signup_purpose_other"
                        maxlength="200"
                        placeholder=" ">
                      <label for="signupPurposeOther">Please describe</label>
                      @if (signupPurposeOtherControl?.invalid && signupPurposeOtherControl?.touched) {
                        <mat-error class="auth-error">
                          @if (signupPurposeOtherControl?.errors?.['required']) {
                            Please describe what you are advertising
                          } @else if (signupPurposeOtherControl?.errors?.['maxlength']) {
                            Description must be 200 characters or fewer
                          }
                        </mat-error>
                      }
                      <p class="purpose-counter">{{ purposeOtherLength }}/{{ purposeOtherMax }}</p>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Business Information (Conditional) -->
            @if (accountTypeControl?.value === 'business') {
              <div class="form-section">
                <h3 class="auth-section-label">Business Information</h3>
                <div class="form-grid">
                  <div class="auth-field auth-field--has-icon">
                    <input class="auth-input" id="companyname" formControlName="companyname" placeholder=" ">
                    <label for="companyname">Company Name</label>
                    @if (companyNameControl?.invalid && companyNameControl?.touched) {
                      <mat-error class="auth-error">
                        @if (companyNameControl?.errors?.['required']) {
                          Company name is required
                        } @else if (companyNameControl?.errors?.['minlength']) {
                          Company name must be at least 2 characters
                        }
                      </mat-error>
                    }
                  </div>
                </div>
              </div>
            }

            <!-- Contact Information -->
            <div class="form-section">
              <h3 class="auth-section-label">Contact Information</h3>
              <div class="form-grid">
                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" id="email" formControlName="email" type="email" placeholder=" ">
                  <label for="email">Email</label>
                  @if (emailControl?.invalid && emailControl?.touched) {
                    <mat-error class="auth-error">
                      @if (emailControl?.errors?.['required']) {
                        Email is required
                      } @else if (emailControl?.errors?.['email']) {
                        Please enter a valid email address
                      }
                    </mat-error>
                  }
                </div>

                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" id="phonenumber" formControlName="phonenumber" type="tel" placeholder=" ">
                  <label for="phonenumber">Mobile Phone Number (optional)</label>
                  @if (phoneNumberControl?.invalid && phoneNumberControl?.touched) {
                    <mat-error class="auth-error">
                      @if (phoneNumberControl?.errors?.['phoneRequiredForNotifications']) {
                        Please provide a phone number to enable text notifications
                      } @else if (phoneNumberControl?.errors?.['pattern']) {
                        Please enter a valid phone number
                      }
                    </mat-error>
                  }
                </div>
              </div>
            </div>

            <!-- Security -->
            <div class="form-section">
              <h3 class="auth-section-label">Security</h3>
              <div class="form-grid">
                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password" placeholder=" ">
                  <label for="password">Password</label>
                  <button type="button" mat-icon-button matSuffix class="auth-field__icon-btn" (click)="showPassword = !showPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showPassword">
                    <mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                  </button>
                  @if (passwordControl?.invalid && passwordControl?.touched) {
                    <mat-error class="auth-error">
                      @if (passwordControl?.errors?.['required']) {
                        Password is required
                      } @else if (passwordControl?.errors?.['minlength']) {
                        Password must be at least 8 characters
                      }
                    </mat-error>
                  }
                </div>

                <div class="auth-field auth-field--has-icon">
                  <input class="auth-input" [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" formControlName="confirmPassword" placeholder=" ">
                  <label for="confirmPassword">Confirm Password</label>
                  <button type="button" mat-icon-button matSuffix class="auth-field__icon-btn" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showConfirmPassword">
                    <mat-icon>{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                  </button>
                  @if (confirmPasswordControl?.invalid && confirmPasswordControl?.touched) {
                    <mat-error class="auth-error">
                      @if (confirmPasswordControl?.errors?.['required']) {
                        Please confirm your password
                      } @else if (confirmPasswordControl?.errors?.['minlength']) {
                        Password must be at least 8 characters
                      } @else if (confirmPasswordControl?.errors?.['passwordMismatch']) {
                        Passwords do not match
                      }
                    </mat-error>
                  }
                </div>
              </div>
            </div>

            <!-- Notifications -->
            <div class="form-section">
              <h3 class="auth-section-label">Notifications</h3>
              <div class="notification-section auth-notification-box">
                <mat-checkbox formControlName="textnotifications" class="notification-checkbox">
                  <div class="checkbox-content">
                    <mat-icon>notifications</mat-icon>
                    <span>Enable Text Notifications</span>
                  </div>
                </mat-checkbox>
                <p class="notification-verification-note">
                  To enable or receive text notifications, you must complete mobile verification during signup.
                </p>
                <p class="notification-note">
                  Checking this box confirms consent to receive automated messages from Radio Ads Direct.
                </p>
              </div>
            </div>

            <div class="form-actions">
              <button type="submit" mat-raised-button color="primary" class="signup-button btn-primary btn-full btn-lg" [disabled]="loading">
                @if (loading) {
                  <span class="btn-spinner"></span>
                }
                <mat-icon>person_add</mat-icon>
                {{ loading ? 'Creating Account...' : 'Create Account' }}
              </button>
            </div>
          </form>

        <div class="signup-footer">
          <p class="auth-footer">Already have an account? <a routerLink="/login" class="login-link">Log in here</a></p>
        </div>
      </div>
    }

    @if (phoneVerificationRequired) {
      <div class="otp-container">
        <div class="auth-card" style="max-width:500px;margin:0 auto">
          <div class="otp-header">
            <img src="assets/logo.png" alt="RAD" class="otp-logo">
            <div class="auth-icon-wrap auth-icon-wrap--purple" style="margin:0 auto 1rem">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18"/>
              </svg>
            </div>
            <h1 class="auth-heading" style="text-align:center">Verify your phone</h1>
            <p class="auth-subheading" style="text-align:center">We sent a 6-digit code to your mobile number</p>
            <div class="verification-details">
              <div class="email-display">
                <mat-icon>sms</mat-icon>
                <span>{{ maskedPhone }}</span>
              </div>
              <p class="verification-requirement-note">
                To enable or receive text notifications, please complete this mobile verification.
              </p>
            </div>
          </div>

          <form [formGroup]="phoneOtpForm" (ngSubmit)="verifyPhone()" class="otp-form">
            <div class="otp-input-section">
              <div class="auth-field">
                <input
                  class="auth-input"
                  formControlName="otp"
                  type="text"
                  inputmode="numeric"
                  maxlength="6"
                  (input)="onPhoneOtpInput($event)"
                  autocomplete="one-time-code"
                  placeholder=" "
                  style="text-align:center; letter-spacing:0.5em">
                <label class="auth-field__label-top">Enter 6-digit code</label>
              </div>
            </div>

            @if (phoneOtpError) {
              <div class="error-message">
                <mat-icon>error</mat-icon>
                <span>{{ phoneOtpError }}</span>
              </div>
            }

            <div class="form-actions">
              <button
                type="submit"
                mat-raised-button
                color="primary"
                class="verify-button btn-primary btn-full btn-lg"
                [disabled]="phoneOtpForm.invalid || phoneVerifyLoading">
                @if (phoneVerifyLoading) {
                  <span class="btn-spinner"></span>
                }
                {{ phoneVerifyLoading ? 'Verifying...' : 'Verify Code' }}
              </button>
            </div>
          </form>

          <div class="resend-section auth-resend">
            <p>Didn't receive the code?</p>
            @if (canResend) {
              <button
                type="button"
                mat-stroked-button
                class="resend-button auth-resend__btn"
                [disabled]="resendLoading || phoneVerifyLoading"
                (click)="resendPhoneOtp()">
                <mat-icon>refresh</mat-icon>
                {{ resendLoading ? 'Sending...' : 'Resend Code' }}
              </button>
            } @else {
              <div class="countdown">
                <mat-icon>schedule</mat-icon>
                <span>Resend available in {{ countdown }}s</span>
              </div>
            }
          </div>

          <div class="otp-footer">
            <p class="auth-footer">Having trouble? <a routerLink="/login" class="help-link">Back to Login</a></p>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="auth-image-container">
    <img src="assets/auth/signupImage.webp" alt="Signup Image">
  </div>
</div>
